import React, { memo, useState } from "react";
import classes from "./ImageView.module.css";
import ImgFrame from "../../../components/common/ImageFrame/ImgFrame";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { Close, Download } from "@mui/icons-material";
import { Box, Modal } from "@mui/material";
import noImageAvailable from "../../../assets/images/png/no-image-available.png";
import { saveAs } from "file-saver";
import {
  getUrlFileExtension,
  isImageUrl,
  isPdfUrl,
  resolveMediaUrl,
} from "../../../utils/mediaUrl";

const ImageView = ({
  customClass,
  imgCustomClass,
  imgSrc,
  label,
  viewClick,
  imgFieldClass,
  widthSize,
  usePdfThumbnail = false,
}) => {
  // view image states
  const [documentImage, setDocumentImage] = useState();
  const [openImageFullView, setOpenImageFullView] = useState(false);

  const normalizedSrc = resolveMediaUrl(imgSrc);
  const extension = getUrlFileExtension(normalizedSrc);
  const fileName = normalizedSrc ? normalizedSrc.split("/").pop()?.split("?")[0] : "";

  const handleOpenImageFullView = (imageSrc) => {
    setOpenImageFullView(true);
    const replacedUrl = resolveMediaUrl(imageSrc);
    setDocumentImage(replacedUrl || noImageAvailable);
  };

  async function downloadimg(url, fileName) {
    const replacedUrl = resolveMediaUrl(url);
    const a = document.createElement("a");
    a.href = await toDataURL(replacedUrl);
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  function toDataURL(url) {
    const replacedUrl = resolveMediaUrl(url);
    return fetch(replacedUrl)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  }

  function DownloadImage(src, fileName) {
    downloadimg(src, fileName);
  }

  const closeViewImagePopup = () => {
    setOpenImageFullView(false);
  };

  const renderPdfThumbnail = () => (
    <iframe
      title={`${fileName || "PDF"} preview`}
      src={`https://docs.google.com/gview?url=${encodeURIComponent(normalizedSrc)}&embedded=true`}
      style={{ width: "100%", height: "100%", border: 0, pointerEvents: "none" }}
    />
  );

  const renderPreview = () => {
    if (!normalizedSrc) {
      return <ImgFrame imgSrc={noImageAvailable} customClass={imgCustomClass} />;
    }

    if (isPdfUrl(normalizedSrc)) {
      if (usePdfThumbnail) return renderPdfThumbnail();
      // Match UAT-style viewing: use Google viewer for PDFs.
      const googleViewerSrc = `https://docs.google.com/gview?url=${encodeURIComponent(normalizedSrc)}&embedded=true`;
      return (
        <div style={{ width: "100%" }}>
          <iframe
            title={fileName || "PDF Viewer"}
            src={googleViewerSrc}
            style={{
              width: "100%",
              height: "240px",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              background: "#fff",
            }}
          />
        </div>
      );
    }

    if (isImageUrl(normalizedSrc)) {
      return <ImgFrame imgSrc={normalizedSrc} customClass={imgCustomClass} />;
    }

    return <ImgFrame imgSrc={noImageAvailable} customClass={imgCustomClass} />;
  };

  return (
    <div
      className={`${classes?.imgViewWrapper || ""} ${customClass || ""}`}
      style={{
        width: widthSize || "100px",
      }}
    >
      <div className={`${classes.imgField} ${imgFieldClass}`}>
        <RemoveRedEyeIcon
          className={classes.viewfullImageIcon}
          onClick={() => {
            handleOpenImageFullView(imgSrc);
          }}
        />
        <Download
          className={classes.downloadFileIcon}
          sx={{
            fontSize: "1.8rem",
          }}
          onClick={() => {
            DownloadImage(imgSrc, fileName)
          }}
        />
        {renderPreview()}
      </div>
      <p className={classes.label}>{label}</p>

      {/* view full image popup */}
      <Modal
        open={openImageFullView}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            outline: "none",
            maxWidth: "90vw",
            maxHeight: "90vh",
          }}
        >
          <div className={classes.fullImageViewWrap}>
            <Close
              className={classes.closeBtn}
              onClick={() => {
                closeViewImagePopup();
              }}
            />
            <div className={classes.fullImageView}>
              {isPdfUrl(normalizedSrc) ? (
                <div className={classes.pdfWrapper}>
                  <p>{fileName}</p>
                  <div className={classes.pdfLinks}>
                    <a
                      href={`https://docs.google.com/gview?url=${encodeURIComponent(normalizedSrc)}&embedded=true`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Open PDF in new tab
                    </a>
                    <a href={normalizedSrc} target="_blank" rel="noreferrer">
                      Open original file
                    </a>
                  </div>
                  <iframe
                    title={fileName || "PDF Viewer"}
                    src={`https://docs.google.com/gview?url=${encodeURIComponent(normalizedSrc)}&embedded=true`}
                    style={{
                      width: "100%",
                      height: "70vh",
                      border: "1px solid #e5e7eb",
                      borderRadius: "12px",
                      background: "#fff",
                    }}
                  />
                </div>
              ) : (
                <img
                  src={documentImage}
                  alt="Full View"
                  className={classes.fullImage}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default memo(ImageView);
